
import contentPartner1 from "assets/content-partners/SVRLogo.png";
import contentPartner2 from "assets/content-partners/360-cities.png";
import contentPartner3 from "assets/content-partners/Wild-Immersion.png";
import contentPartner4 from "assets/content-partners/CareerView.png";
import contentPartner5 from "assets/content-partners/APS.png";
import contentPartner6 from "assets/content-partners/Nextexhoasis.png";
import contentPartner7 from "assets/content-partners/Blend-Media.png";

export const subjects = [
    { name: 'Science', icon: 'science' },
    { name: 'Technology', icon: 'memory' },
    { name: 'Environment', icon: 'eco' },
    { name: 'Financial Literacy', icon: 'account_balance' },
    { name: 'Wildlife', icon: 'pets' },
    { name: '360 Cities', icon: 'map' },
    { name: 'Career', icon: 'work' },
    { name: 'Social Emotional', icon: 'self_improvement' },
    { name: 'English', icon: 'book' },
    { name: 'Interactive STEM', icon: 'science' },
];

export const partners = [
    {
        name: 'Partner 1',
        logo: contentPartner1,
    },
    {
        name: 'Partner 2',
        logo: contentPartner2,
        url: '/library/360-cities'
    },
    {
        name: 'Partner 3',
        logo: contentPartner3,
         url: '/library/wildlife'
    },
    {
        name: 'Partner 4',
        logo: contentPartner4,
        url: '/library/career'
    },
    {
        name: 'Partner 5',
        logo: contentPartner5,
        url: '/library/amazing-people'
    },
    {
        name: 'Partner 6',
        logo: contentPartner6,
        url: '/library/interactive-stem'
    },
    {
        name: 'Partner 7',
        logo: contentPartner7,
        url: '/library/blend-media'
    },
];

export const featuredModules = [
    {
        "id": "science-module-1",
        "title": "Science Module #1",
        "description": "An immersive journey into topic 1 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Anya Sharma",
            "title": "Climatologist"
        },
        "duration": "38 minutes",
        "durationMinutes": 38,
        "skillLevel": "Advanced",
        "category": "Science",
        "age": "12-16",
        "keywords": ["Science", "VR", "Education"],
        "language": "English"
    },
    {
        "id": "science-module-2",
        "title": "Science Module #2",
        "description": "An immersive journey into topic 2 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 5 minutes",
        "durationMinutes": 125,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-3",
        "title": "Science Module #3",
        "description": "An immersive journey into topic 3 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 46 minutes",
        "durationMinutes": 166,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-4",
        "title": "Science Module #4",
        "description": "An immersive journey into topic 4 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 2 minutes",
        "durationMinutes": 62,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-5",
        "title": "Science Module #5",
        "description": "An immersive journey into topic 5 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Chloe Evans",
            "title": "Environmental Scientist"
        },
        "duration": "3 hours",
        "durationMinutes": 180,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-6",
        "title": "Science Module #6",
        "description": "An immersive journey into topic 6 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 27 minutes",
        "durationMinutes": 147,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-7",
        "title": "Science Module #7",
        "description": "An immersive journey into topic 7 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 1 minute",
        "durationMinutes": 121,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-8",
        "title": "Science Module #8",
        "description": "An immersive journey into topic 8 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 24 minutes",
        "durationMinutes": 84,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-9",
        "title": "Science Module #9",
        "description": "An immersive journey into topic 9 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 2 minutes",
        "durationMinutes": 122,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-10",
        "title": "Science Module #10",
        "description": "An immersive journey into topic 10 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 19 minutes",
        "durationMinutes": 79,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-11",
        "title": "Science Module #11",
        "description": "An immersive journey into topic 11 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 11 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-11/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 11",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Kenji Tanaka",
            "title": "Marine Biologist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-12",
        "title": "Science Module #12",
        "description": "An immersive journey into topic 12 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 12 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-12/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 12",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 56 minutes",
        "durationMinutes": 176,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-13",
        "title": "Science Module #13",
        "description": "An immersive journey into topic 13 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 13 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-13/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 13",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Chloe Evans",
            "title": "Environmental Scientist"
        },
        "duration": "1 hour 2 minutes",
        "durationMinutes": 62,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-14",
        "title": "Science Module #14",
        "description": "An immersive journey into topic 14 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 14 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-14/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 14",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 28 minutes",
        "durationMinutes": 148,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-15",
        "title": "Science Module #15",
        "description": "An immersive journey into topic 15 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 15 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-15/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 15",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 45 minutes",
        "durationMinutes": 165,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-16",
        "title": "Science Module #16",
        "description": "An immersive journey into topic 16 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 16 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-16/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 16",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 37 minutes",
        "durationMinutes": 157,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-17",
        "title": "Science Module #17",
        "description": "An immersive journey into topic 17 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 17 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-17/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 17",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Chloe Evans",
            "title": "Environmental Scientist"
        },
        "duration": "2 hours 2 minutes",
        "durationMinutes": 122,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-18",
        "title": "Science Module #18",
        "description": "An immersive journey into topic 18 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 18 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-18/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 18",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 2 minutes",
        "durationMinutes": 62,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-19",
        "title": "Science Module #19",
        "description": "An immersive journey into topic 19 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 19 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-19/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 19",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours 55 minutes",
        "durationMinutes": 175,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-20",
        "title": "Science Module #20",
        "description": "An immersive journey into topic 20 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 20 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-20/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 20",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 3 minutes",
        "durationMinutes": 123,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-21",
        "title": "Science Module #21",
        "description": "An immersive journey into topic 21 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 21 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-21/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 21",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours 18 minutes",
        "durationMinutes": 138,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-22",
        "title": "Science Module #22",
        "description": "An immersive journey into topic 22 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 22 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-22/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 22",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-23",
        "title": "Science Module #23",
        "description": "An immersive journey into topic 23 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 23 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-23/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 23",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 3 minutes",
        "durationMinutes": 123,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-24",
        "title": "Science Module #24",
        "description": "An immersive journey into topic 24 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 24 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-24/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 24",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Chloe Evans",
            "title": "Environmental Scientist"
        },
        "duration": "1 hour 25 minutes",
        "durationMinutes": 85,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-25",
        "title": "Science Module #25",
        "description": "An immersive journey into topic 25 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 25 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-25/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 25",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 2 minutes",
        "durationMinutes": 122,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-26",
        "title": "Science Module #26",
        "description": "An immersive journey into topic 26 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 26 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-26/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 26",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 4 minutes",
        "durationMinutes": 64,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-27",
        "title": "Science Module #27",
        "description": "An immersive journey into topic 27 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 27 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-27/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 27",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 4 minutes",
        "durationMinutes": 64,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-28",
        "title": "Science Module #28",
        "description": "An immersive journey into topic 28 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 28 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-28/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 28",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 28 minutes",
        "durationMinutes": 148,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-29",
        "title": "Science Module #29",
        "description": "An immersive journey into topic 29 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 29 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-29/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 29",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 32 minutes",
        "durationMinutes": 152,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-30",
        "title": "Science Module #30",
        "description": "An immersive journey into topic 30 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 30 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-30/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 30",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "1 hour 24 minutes",
        "durationMinutes": 84,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-31",
        "title": "Science Module #31",
        "description": "An immersive journey into topic 31 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 31 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-31/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 31",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-32",
        "title": "Science Module #32",
        "description": "An immersive journey into topic 32 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 32 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-32/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 32",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 17 minutes",
        "durationMinutes": 137,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-33",
        "title": "Science Module #33",
        "description": "An immersive journey into topic 33 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 33 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-33/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 33",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 32 minutes",
        "durationMinutes": 152,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-34",
        "title": "Science Module #34",
        "description": "An immersive journey into topic 34 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 34 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-34/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 34",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-35",
        "title": "Science Module #35",
        "description": "An immersive journey into topic 35 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 35 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-35/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 35",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 17 minutes",
        "durationMinutes": 137,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-36",
        "title": "Science Module #36",
        "description": "An immersive journey into topic 36 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 36 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-36/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 36",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 2 minutes",
        "durationMinutes": 62,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-37",
        "title": "Science Module #37",
        "description": "An immersive journey into topic 37 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 37 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-37/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 37",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 35 minutes",
        "durationMinutes": 95,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-38",
        "title": "Science Module #38",
        "description": "An immersive journey into topic 38 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 38 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-38/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 38",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 22 minutes",
        "durationMinutes": 142,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-39",
        "title": "Science Module #39",
        "description": "An immersive journey into topic 39 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 39 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-39/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 39",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 12 minutes",
        "durationMinutes": 132,
        "skillLevel": "Intermediate",
        "category": "Science"
    },
    {
        "id": "science-module-40",
        "title": "Science Module #40",
        "description": "An immersive journey into topic 40 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 40 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-40/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 40",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-41",
        "title": "Science Module #41",
        "description": "An immersive journey into topic 41 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 41 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-41/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 41",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Kenji Tanaka",
            "title": "Marine Biologist"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-42",
        "title": "Science Module #42",
        "description": "An immersive journey into topic 42 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 42 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-42/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 42",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 44 minutes",
        "durationMinutes": 164,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "science-module-43",
        "title": "Science Module #43",
        "description": "An immersive journey into topic 43 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 43 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-43/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 43",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-44",
        "title": "Science Module #44",
        "description": "An immersive journey into topic 44 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 44 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-44/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 44",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 1 minute",
        "durationMinutes": 121,
        "skillLevel": "Advanced",
        "category": "Science"
    },
    {
        "id": "science-module-45",
        "title": "Science Module #45",
        "description": "An immersive journey into topic 45 within Science.",
        "longDescription": "This module provides a comprehensive exploration of topic number 45 in the field of Science. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/science-module-45/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 45",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Chloe Evans",
            "title": "Environmental Scientist"
        },
        "duration": "2 hours 18 minutes",
        "durationMinutes": 138,
        "skillLevel": "Beginner",
        "category": "Science"
    },
    {
        "id": "technology-module-1",
        "title": "Technology Module #1",
        "description": "An immersive journey into topic 1 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 30 minutes",
        "durationMinutes": 90,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-2",
        "title": "Technology Module #2",
        "description": "An immersive journey into topic 2 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-3",
        "title": "Technology Module #3",
        "description": "An immersive journey into topic 3 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-4",
        "title": "Technology Module #4",
        "description": "An immersive journey into topic 4 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 55 minutes",
        "durationMinutes": 115,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-5",
        "title": "Technology Module #5",
        "description": "An immersive journey into topic 5 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 45 minutes",
        "durationMinutes": 165,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-6",
        "title": "Technology Module #6",
        "description": "An immersive journey into topic 6 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 10 minutes",
        "durationMinutes": 70,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-7",
        "title": "Technology Module #7",
        "description": "An immersive journey into topic 7 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-8",
        "title": "Technology Module #8",
        "description": "An immersive journey into topic 8 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "3 hours",
        "durationMinutes": 180,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-9",
        "title": "Technology Module #9",
        "description": "An immersive journey into topic 9 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-10",
        "title": "Technology Module #10",
        "description": "An immersive journey into topic 10 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 40 minutes",
        "durationMinutes": 100,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-11",
        "title": "Technology Module #11",
        "description": "An immersive journey into topic 11 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 11 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-11/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 11",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-12",
        "title": "Technology Module #12",
        "description": "An immersive journey into topic 12 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 12 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-12/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 12",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-13",
        "title": "Technology Module #13",
        "description": "An immersive journey into topic 13 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 13 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-13/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 13",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 10 minutes",
        "durationMinutes": 130,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-14",
        "title": "Technology Module #14",
        "description": "An immersive journey into topic 14 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 14 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-14/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 14",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 50 minutes",
        "durationMinutes": 170,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-15",
        "title": "Technology Module #15",
        "description": "An immersive journey into topic 15 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 15 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-15/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 15",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "35 minutes",
        "durationMinutes": 35,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-16",
        "title": "Technology Module #16",
        "description": "An immersive journey into topic 16 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 16 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-16/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 16",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 50 minutes",
        "durationMinutes": 110,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-17",
        "title": "Technology Module #17",
        "description": "An immersive journey into topic 17 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 17 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-17/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 17",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-18",
        "title": "Technology Module #18",
        "description": "An immersive journey into topic 18 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 18 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-18/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 18",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 20 minutes",
        "durationMinutes": 80,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-19",
        "title": "Technology Module #19",
        "description": "An immersive journey into topic 19 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 19 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-19/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 19",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 35 minutes",
        "durationMinutes": 95,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-20",
        "title": "Technology Module #20",
        "description": "An immersive journey into topic 20 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 20 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-20/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 20",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 25 minutes",
        "durationMinutes": 145,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-21",
        "title": "Technology Module #21",
        "description": "An immersive journey into topic 21 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 21 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-21/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 21",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "40 minutes",
        "durationMinutes": 40,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-22",
        "title": "Technology Module #22",
        "description": "An immersive journey into topic 22 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 22 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-22/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 22",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-23",
        "title": "Technology Module #23",
        "description": "An immersive journey into topic 23 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 23 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-23/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 23",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 55 minutes",
        "durationMinutes": 175,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-24",
        "title": "Technology Module #24",
        "description": "An immersive journey into topic 24 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 24 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-24/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 24",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-25",
        "title": "Technology Module #25",
        "description": "An immersive journey into topic 25 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 25 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-25/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 25",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-26",
        "title": "Technology Module #26",
        "description": "An immersive journey into topic 26 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 26 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-26/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 26",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 35 minutes",
        "durationMinutes": 155,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-27",
        "title": "Technology Module #27",
        "description": "An immersive journey into topic 27 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 27 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-27/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 27",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "55 minutes",
        "durationMinutes": 55,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-28",
        "title": "Technology Module #28",
        "description": "An immersive journey into topic 28 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 28 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-28/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 28",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 25 minutes",
        "durationMinutes": 85,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-29",
        "title": "Technology Module #29",
        "description": "An immersive journey into topic 29 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 29 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-29/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 29",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 5 minutes",
        "durationMinutes": 125,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-30",
        "title": "Technology Module #30",
        "description": "An immersive journey into topic 30 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 30 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-30/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 30",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-31",
        "title": "Technology Module #31",
        "description": "An immersive journey into topic 31 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 31 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-31/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 31",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 55 minutes",
        "durationMinutes": 115,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-32",
        "title": "Technology Module #32",
        "description": "An immersive journey into topic 32 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 32 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-32/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 32",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 45 minutes",
        "durationMinutes": 165,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-33",
        "title": "Technology Module #33",
        "description": "An immersive journey into topic 33 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 33 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-33/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 33",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-34",
        "title": "Technology Module #34",
        "description": "An immersive journey into topic 34 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 34 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-34/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 34",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 50 minutes",
        "durationMinutes": 110,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-35",
        "title": "Technology Module #35",
        "description": "An immersive journey into topic 35 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 35 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-35/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 35",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-36",
        "title": "Technology Module #36",
        "description": "An immersive journey into topic 36 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 36 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-36/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 36",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 20 minutes",
        "durationMinutes": 80,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-37",
        "title": "Technology Module #37",
        "description": "An immersive journey into topic 37 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 37 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-37/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 37",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 35 minutes",
        "durationMinutes": 95,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-38",
        "title": "Technology Module #38",
        "description": "An immersive journey into topic 38 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 38 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-38/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 38",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 25 minutes",
        "durationMinutes": 145,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-39",
        "title": "Technology Module #39",
        "description": "An immersive journey into topic 39 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 39 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-39/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 39",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "40 minutes",
        "durationMinutes": 40,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-40",
        "title": "Technology Module #40",
        "description": "An immersive journey into topic 40 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 40 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-40/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 40",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-41",
        "title": "Technology Module #41",
        "description": "An immersive journey into topic 41 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 41 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-41/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 41",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 55 minutes",
        "durationMinutes": 175,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-42",
        "title": "Technology Module #42",
        "description": "An immersive journey into topic 42 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 42 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-42/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 42",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "technology-module-43",
        "title": "Technology Module #43",
        "description": "An immersive journey into topic 43 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 43 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-43/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 43",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Ben Carter",
            "title": "AI Ethicist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Intermediate",
        "category": "Technology"
    },
    {
        "id": "technology-module-44",
        "title": "Technology Module #44",
        "description": "An immersive journey into topic 44 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 44 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-44/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 44",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 35 minutes",
        "durationMinutes": 155,
        "skillLevel": "Advanced",
        "category": "Technology"
    },
    {
        "id": "technology-module-45",
        "title": "Technology Module #45",
        "description": "An immersive journey into topic 45 within Technology.",
        "longDescription": "This module provides a comprehensive exploration of topic number 45 in the field of Technology. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/technology-module-45/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 45",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "55 minutes",
        "durationMinutes": 55,
        "skillLevel": "Beginner",
        "category": "Technology"
    },
    {
        "id": "english-module-1",
        "title": "English Module #1",
        "description": "An immersive journey into topic 1 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-2",
        "title": "English Module #2",
        "description": "An immersive journey into topic 2 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-3",
        "title": "English Module #3",
        "description": "An immersive journey into topic 3 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-4",
        "title": "English Module #4",
        "description": "An immersive journey into topic 4 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-5",
        "title": "English Module #5",
        "description": "An immersive journey into topic 5 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-6",
        "title": "English Module #6",
        "description": "An immersive journey into topic 6 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-7",
        "title": "English Module #7",
        "description": "An immersive journey into topic 7 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-8",
        "title": "English Module #8",
        "description": "An immersive journey into topic 8 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-9",
        "title": "English Module #9",
        "description": "An immersive journey into topic 9 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-10",
        "title": "English Module #10",
        "description": "An immersive journey into topic 10 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-11",
        "title": "English Module #11",
        "description": "An immersive journey into topic 11 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 11 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-11/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 11",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 45 minutes",
        "durationMinutes": 165,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-12",
        "title": "English Module #12",
        "description": "An immersive journey into topic 12 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 12 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-12/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 12",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "35 minutes",
        "durationMinutes": 35,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-13",
        "title": "English Module #13",
        "description": "An immersive journey into topic 13 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 13 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-13/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 13",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 20 minutes",
        "durationMinutes": 80,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-14",
        "title": "English Module #14",
        "description": "An immersive journey into topic 14 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 14 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-14/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 14",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 10 minutes",
        "durationMinutes": 130,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-15",
        "title": "English Module #15",
        "description": "An immersive journey into topic 15 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 15 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-15/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 15",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "55 minutes",
        "durationMinutes": 55,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-16",
        "title": "English Module #16",
        "description": "An immersive journey into topic 16 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 16 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-16/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 16",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 25 minutes",
        "durationMinutes": 85,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-17",
        "title": "English Module #17",
        "description": "An immersive journey into topic 17 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 17 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-17/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 17",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-18",
        "title": "English Module #18",
        "description": "An immersive journey into topic 18 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 18 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-18/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 18",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "40 minutes",
        "durationMinutes": 40,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-19",
        "title": "English Module #19",
        "description": "An immersive journey into topic 19 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 19 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-19/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 19",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 50 minutes",
        "durationMinutes": 110,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-20",
        "title": "English Module #20",
        "description": "An immersive journey into topic 20 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 20 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-20/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 20",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 5 minutes",
        "durationMinutes": 125,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-21",
        "title": "English Module #21",
        "description": "An immersive journey into topic 21 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 21 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-21/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 21",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 10 minutes",
        "durationMinutes": 70,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-22",
        "title": "English Module #22",
        "description": "An immersive journey into topic 22 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 22 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-22/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 22",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 30 minutes",
        "durationMinutes": 90,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-23",
        "title": "English Module #23",
        "description": "An immersive journey into topic 23 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 23 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-23/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 23",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 40 minutes",
        "durationMinutes": 160,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-24",
        "title": "English Module #24",
        "description": "An immersive journey into topic 24 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 24 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-24/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 24",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "25 minutes",
        "durationMinutes": 25,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-25",
        "title": "English Module #25",
        "description": "An immersive journey into topic 25 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 25 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-25/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 25",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 55 minutes",
        "durationMinutes": 115,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-26",
        "title": "English Module #26",
        "description": "An immersive journey into topic 26 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 26 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-26/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 26",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 50 minutes",
        "durationMinutes": 170,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-27",
        "title": "English Module #27",
        "description": "An immersive journey into topic 27 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 27 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-27/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 27",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 35 minutes",
        "durationMinutes": 95,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-28",
        "title": "English Module #28",
        "description": "An immersive journey into topic 28 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 28 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-28/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 28",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 40 minutes",
        "durationMinutes": 100,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-29",
        "title": "English Module #29",
        "description": "An immersive journey into topic 29 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 29 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-29/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 29",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "3 hours",
        "durationMinutes": 180,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-30",
        "title": "English Module #30",
        "description": "An immersive journey into topic 30 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 30 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-30/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 30",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "20 minutes",
        "durationMinutes": 20,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-31",
        "title": "English Module #31",
        "description": "An immersive journey into topic 31 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 31 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-31/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 31",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 25 minutes",
        "durationMinutes": 145,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-32",
        "title": "English Module #32",
        "description": "An immersive journey into topic 32 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 32 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-32/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 32",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "3 hours 10 minutes",
        "durationMinutes": 190,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-33",
        "title": "English Module #33",
        "description": "An immersive journey into topic 33 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 33 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-33/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 33",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 50 minutes",
        "durationMinutes": 110,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-34",
        "title": "English Module #34",
        "description": "An immersive journey into topic 34 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 34 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-34/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 34",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-35",
        "title": "English Module #35",
        "description": "An immersive journey into topic 35 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 35 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-35/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 35",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-36",
        "title": "English Module #36",
        "description": "An immersive journey into topic 36 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 36 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-36/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 36",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-37",
        "title": "English Module #37",
        "description": "An immersive journey into topic 37 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 37 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-37/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 37",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 55 minutes",
        "durationMinutes": 175,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-38",
        "title": "English Module #38",
        "description": "An immersive journey into topic 38 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 38 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-38/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 38",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "3 hours 20 minutes",
        "durationMinutes": 200,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-39",
        "title": "English Module #39",
        "description": "An immersive journey into topic 39 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 39 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-39/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 39",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 5 minutes",
        "durationMinutes": 125,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-40",
        "title": "English Module #40",
        "description": "An immersive journey into topic 40 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 40 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-40/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 40",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 4",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 10 minutes",
        "durationMinutes": 70,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-41",
        "title": "English Module #41",
        "description": "An immersive journey into topic 41 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 41 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-41/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 41",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 5",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-42",
        "title": "English Module #42",
        "description": "An immersive journey into topic 42 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 42 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-42/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 42",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 6",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "1 hour 20 minutes",
        "durationMinutes": 80,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "english-module-43",
        "title": "English Module #43",
        "description": "An immersive journey into topic 43 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 43 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-43/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 43",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 1",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "3 hours 5 minutes",
        "durationMinutes": 185,
        "skillLevel": "Beginner",
        "category": "English"
    },
    {
        "id": "english-module-44",
        "title": "English Module #44",
        "description": "An immersive journey into topic 44 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 44 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-44/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 44",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 2",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "3 hours 30 minutes",
        "durationMinutes": 210,
        "skillLevel": "Intermediate",
        "category": "English"
    },
    {
        "id": "english-module-45",
        "title": "English Module #45",
        "description": "An immersive journey into topic 45 within English.",
        "longDescription": "This module provides a comprehensive exploration of topic number 45 in the field of English. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/english-module-45/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 45",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Partner 3",
        "instructor": {
            "name": "Dr. Emily Carter",
            "title": "Linguist"
        },
        "duration": "2 hours 20 minutes",
        "durationMinutes": 140,
        "skillLevel": "Advanced",
        "category": "English"
    },
    {
        "id": "wildlife-module-1",
        "title": "Wildlife Module #1",
        "description": "An immersive journey into topic 1 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-2",
        "title": "Wildlife Module #2",
        "description": "An immersive journey into topic 2 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-3",
        "title": "Wildlife Module #3",
        "description": "An immersive journey into topic 3 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-4",
        "title": "Wildlife Module #4",
        "description": "An immersive journey into topic 4 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-5",
        "title": "Wildlife Module #5",
        "description": "An immersive journey into topic 5 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-6",
        "title": "Wildlife Module #6",
        "description": "An immersive journey into topic 6 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-7",
        "title": "Wildlife Module #7",
        "description": "An immersive journey into topic 7 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-8",
        "title": "Wildlife Module #8",
        "description": "An immersive journey into topic 8 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-9",
        "title": "Wildlife Module #9",
        "description": "An immersive journey into topic 9 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "Wildlife"
    },
    {
        "id": "wildlife-module-10",
        "title": "Wildlife Module #10",
        "description": "An immersive journey into topic 10 within Wildlife.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Wildlife. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/wildlife-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Wild Immersion",
        "instructor": {
            "name": "Dr. Jane Goodall",
            "title": "Primatologist"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "Wildlife"
    },
    {
        "id": "interactive-stem-module-1",
        "title": "Interactive STEM Module #1",
        "description": "An immersive journey into topic 1 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-2",
        "title": "Interactive STEM Module #2",
        "description": "An immersive journey into topic 2 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-3",
        "title": "Interactive STEM Module #3",
        "description": "An immersive journey into topic 3 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-4",
        "title": "Interactive STEM Module #4",
        "description": "An immersive journey into topic 4 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-5",
        "title": "Interactive STEM Module #5",
        "description": "An immersive journey into topic 5 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-6",
        "title": "Interactive STEM Module #6",
        "description": "An immersive journey into topic 6 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-7",
        "title": "Interactive STEM Module #7",
        "description": "An immersive journey into topic 7 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-8",
        "title": "Interactive STEM Module #8",
        "description": "An immersive journey into topic 8 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-9",
        "title": "Interactive STEM Module #9",
        "description": "An immersive journey into topic 9 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "Interactive STEM"
    },
    {
        "id": "interactive-stem-module-10",
        "title": "Interactive STEM Module #10",
        "description": "An immersive journey into topic 10 within Interactive STEM.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Interactive STEM. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/interactive-stem-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Nextechoasis",
        "instructor": {
            "name": "Dr. Evelyn Reed",
            "title": "Quantum Physicist"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "Interactive STEM"
    },
    {
        "id": "career-module-1",
        "title": "Career Module #1",
        "description": "An immersive journey into topic 1 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "Career"
    },
    {
        "id": "career-module-2",
        "title": "Career Module #2",
        "description": "An immersive journey into topic 2 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "Career"
    },
    {
        "id": "career-module-3",
        "title": "Career Module #3",
        "description": "An immersive journey into topic 3 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "Career"
    },
    {
        "id": "career-module-4",
        "title": "Career Module #4",
        "description": "An immersive journey into topic 4 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Career"
    },
    {
        "id": "career-module-5",
        "title": "Career Module #5",
        "description": "An immersive journey into topic 5 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "Career"
    },
    {
        "id": "career-module-6",
        "title": "Career Module #6",
        "description": "An immersive journey into topic 6 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "Career"
    },
    {
        "id": "career-module-7",
        "title": "Career Module #7",
        "description": "An immersive journey into topic 7 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "Career"
    },
    {
        "id": "career-module-8",
        "title": "Career Module #8",
        "description": "An immersive journey into topic 8 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "Career"
    },
    {
        "id": "career-module-9",
        "title": "Career Module #9",
        "description": "An immersive journey into topic 9 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "Career"
    },
    {
        "id": "career-module-10",
        "title": "Career Module #10",
        "description": "An immersive journey into topic 10 within Career.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Career. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/career-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "CareerViewXR",
        "instructor": {
            "name": "Dr. David Lee",
            "title": "Economist"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "Career"
    },
    {
        "id": "360-cities-module-1",
        "title": "360 Cities Module #1",
        "description": "An immersive journey into topic 1 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-2",
        "title": "360 Cities Module #2",
        "description": "An immersive journey into topic 2 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-3",
        "title": "360 Cities Module #3",
        "description": "An immersive journey into topic 3 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-4",
        "title": "360 Cities Module #4",
        "description": "An immersive journey into topic 4 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-5",
        "title": "360 Cities Module #5",
        "description": "An immersive journey into topic 5 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-6",
        "title": "360 Cities Module #6",
        "description": "An immersive journey into topic 6 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-7",
        "title": "360 Cities Module #7",
        "description": "An immersive journey into topic 7 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-8",
        "title": "360 Cities Module #8",
        "description": "An immersive journey into topic 8 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-9",
        "title": "360 Cities Module #9",
        "description": "An immersive journey into topic 9 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "360 Cities"
    },
    {
        "id": "360-cities-module-10",
        "title": "360 Cities Module #10",
        "description": "An immersive journey into topic 10 within 360 Cities.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of 360 Cities. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/360-cities-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "360 cities",
        "instructor": {
            "name": "Dr. Alex Mercer",
            "title": "Science Researcher"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "360 Cities"
    },
    {
        "id": "social-emotional-module-1",
        "title": "Social Emotional Module #1",
        "description": "An immersive journey into topic 1 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 1 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-1/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 1",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 15 minutes",
        "durationMinutes": 75,
        "skillLevel": "Beginner",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-2",
        "title": "Social Emotional Module #2",
        "description": "An immersive journey into topic 2 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 2 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-2/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 2",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 30 minutes",
        "durationMinutes": 150,
        "skillLevel": "Intermediate",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-3",
        "title": "Social Emotional Module #3",
        "description": "An immersive journey into topic 3 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 3 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-3/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 3",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "45 minutes",
        "durationMinutes": 45,
        "skillLevel": "Advanced",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-4",
        "title": "Social Emotional Module #4",
        "description": "An immersive journey into topic 4 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 4 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-4/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 4",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 5 minutes",
        "durationMinutes": 65,
        "skillLevel": "Beginner",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-5",
        "title": "Social Emotional Module #5",
        "description": "An immersive journey into topic 5 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 5 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-5/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 5",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours",
        "durationMinutes": 120,
        "skillLevel": "Intermediate",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-6",
        "title": "Social Emotional Module #6",
        "description": "An immersive journey into topic 6 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 6 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-6/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 6",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "30 minutes",
        "durationMinutes": 30,
        "skillLevel": "Advanced",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-7",
        "title": "Social Emotional Module #7",
        "description": "An immersive journey into topic 7 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 7 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-7/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 7",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour 45 minutes",
        "durationMinutes": 105,
        "skillLevel": "Beginner",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-8",
        "title": "Social Emotional Module #8",
        "description": "An immersive journey into topic 8 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 8 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-8/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 8",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "2 hours 15 minutes",
        "durationMinutes": 135,
        "skillLevel": "Intermediate",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-9",
        "title": "Social Emotional Module #9",
        "description": "An immersive journey into topic 9 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 9 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-9/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 9",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "50 minutes",
        "durationMinutes": 50,
        "skillLevel": "Advanced",
        "category": "Social Emotional"
    },
    {
        "id": "social-emotional-module-10",
        "title": "Social Emotional Module #10",
        "description": "An immersive journey into topic 10 within Social Emotional.",
        "longDescription": "This module provides a comprehensive exploration of topic number 10 in the field of Social Emotional. Designed for learners of all levels, it combines theoretical knowledge with practical, hands-on VR simulations.",
        "image": "https://picsum.photos/seed/social-emotional-module-10/400/300",
        "videoUrl": "...",
        "learningObjectives": [
            "Master topic 10",
            "Understand concept A",
            "Apply knowledge B"
        ],
        "partner": "Amazing People Schools",
        "instructor": {
            "name": "Dr. Lena Petrova",
            "title": "Organizational Psychologist"
        },
        "duration": "1 hour",
        "durationMinutes": 60,
        "skillLevel": "Beginner",
        "category": "Social Emotional"
    }
];
